<template>
    <v-container fluid class="pr-0 pl-0">
        <logo @cambiaAnio="listarAccionReduccion" v-sticky="{ zIndex: 4, stickyTop: 65}" />
        <navParameters :navParams="navParams"/>
        <v-row>
            <v-col cols="12">
                <tituloPrincipal titulo="Prácticas ambientalmente positivas en los procesos de producción"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6" md="3" align-self="center">
                <Agregar @reload="listarAccionReduccion" />
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="6" md="2">
                <v-text-field
                    prepend-inner-icon="mdi-magnify"
                    label="Buscar"
                    v-model="search"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-card>
            <tituloSimple titulo="Prácticas ambientalmente positivas en los procesos de producción"/>
            <v-divider></v-divider>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="data"
                    item-key="id"
                    :search="search">
                    <template v-slot:item.action="{ item }">
                        <Modificar 
                            v-if="rolUsuario != 'CEO' && rolUsuario != 'GERENTE' && rolUsuario != 'SUPERVISOR'" 
                            @reload="listarAccionReduccion" 
                            v-bind:accion1="item" 
                        />
                        <AgregarEvidencia
                            v-if="rolUsuario != 'CEO' && rolUsuario != 'GERENTE' && rolUsuario != 'SUPERVISOR'"
                            @reload="listarAccionReduccion"
                            :idAccion="item.id"
                            origen="practicasAgropecuarias"
                            tooltipText="Agregar Evidencias"
                            titulo="Evidencias"
                        ></AgregarEvidencia>
                    </template>
                    <template v-slot:item.evidencia="{ item }">
                        <ListadosDocs :idActividad="item.id" :idAccion="item.id"  origen="accionReduccion" titulo="Evidencias"></ListadosDocs>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>

import Modificar from "@/components/parametros/AccionReduccion/ModificarAccionReduccionComponent"
import Agregar from '@/components/parametros/InsumosAgropecuarios/AgregarPracticaAgrop.vue'
import ListadosDocs from "@/components/documentos/ListadoDocumentosComponent"
import AgregarEvidencia from "@/components/utils/AgregarEvidenciaComponent"
import TituloPrincipal from '@/components/utils/TituloPrincipalComponent'
import NavParameters from '@/components/utils/NavParameterComponent'
import TituloSimple from '@/components/utils/TituloSimpleComponent'
import Logo from '@/components/utils/CompanyComponent'
import VueSticky from 'vue-sticky'
import axios from "@/axios.js";

export default {

    created() {
        axios.defaults.headers.common['Authorization'] = "Bearer " + this.$store.getters.token;
    },  
    computed: {
        sucursal() {
            return this.$store.getters.sucursal;
        },
        indicadorActual() {
            return this.$store.getters.indicadorActual;
        },
        instalacion() {
            return this.$store.getters.sucursal;
        },
        rolUsuario(){
            return this.$store.getters.usuario.rol;
        },
        anioConsulta() {
            return this. $store.getters.anioConsulta;
        },
        buenasPractcas() {
            let constantes = this.$store.getters.constantes;
            return constantes.TIPO_ACTIVIDAD.BUENAS_PRACTICAS
        },
    },
    directives: {
        'sticky': VueSticky,
    },
    props: [
        'navParams'
    ],
    components: {
        Agregar,
        Modificar,
        ListadosDocs,
        AgregarEvidencia,
        TituloSimple,
        NavParameters,
        TituloPrincipal,
        Logo
    },
    data: () => ({
        search: null,
        data: [],
        headers: [
            {
                text: "Acciones",
                value: "action",
                align: "center",
            },
            {
                text: "Tipo",
                value: "tipoActividad",
                align: "start",
            },
            {
                text: "Detalle la práctica",
                value: "descripcion",
                align: "start",
            },
            {
                text: "Fecha de inplementación",
                value: "fechaActividad",
                align: "center",
            },
            {
                text: "Evidencia",
                value: "evidencia",
                align: "center",
            },
        ]
    }),
    mounted () {
        this.listarAccionReduccion();
    },
    methods: {
        listarAccionReduccion(){
            let idInstalacion = this.sucursal.id;
            let indicador = this.indicadorActual;
            let year = this.anioConsulta;
            axios.get(`/accionReduccion/listarAccionesReduccion/${idInstalacion}/${indicador}`,{ params:{year: year, tipo: this.buenasPractcas} }).then(response => {
                this.data = response.data.acciones;
                this.paginaCargada(false);
            }).catch(error => {
              if (error.request && error.request.status === 401) {
                this.$store.commit('showSessionDialog', true);
              } else {
                console.log(error);
                this.paginaCargada(false);
              }
            })
        },
        paginaCargada() {
            this.$store.dispatch('loadingPage', false);
        },
        
    },
}
</script>